import React from 'react';
import { useTranslation } from 'react-i18next';

import authStyles from '../auth-shared-styles/AuthSharedStyles.module.scss';
import styles from './MobileNotSupported.module.scss';

export const MobileNotSupported = () => {
  const { t } = useTranslation('common');

  return (
    <div
      className={authStyles.layout}
      style={{ backgroundImage: `url('/app/static/images/auth/sun.png')` }}
    >
      <section className={styles.section} data-testid="mobile-not-supported">
        <div className={styles.wrapper}>
          <img
            className={styles.mobile}
            src="/app/static/images/icons/mobile-with-sad-face.svg"
            alt=""
          />
          <p className={styles.title}>{t('common:smallScreensNotSupported')}</p>
          <p className={styles.description}>{t('common:switchToDesktop')}</p>
        </div>
      </section>
    </div>
  );
};
